import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="flex justify-center">
      <div className="relative">
        <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
        <div className="absolute inset-0 w-16 h-16 border-4 border-transparent border-t-purple-600 rounded-full animate-spin" style={{ animationDelay: '-0.5s' }}></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
